<div class="mat-dialog-custom confirmation-dialog" [id]="dialogId">
  @if (titleText) {
    <div class="title-container">
      <h1 class="title">{{ titleText }}</h1>
      @if (hasCloseButton) {
        <a
          class="close-button-container"
          href="javascript:void(0);"
          aria-label="close"
          mat-dialog-close="cancel"
          i18n-aria-label
        >
          <svg-icon src="/assets/icons/close.svg" alt="close" i18n-alt />
        </a>
      }
    </div>
  }

  @if (contentText) {
    <div class="body-container">
      <div class="helper-truncate content-text" [ngClass]="{ 'no-wrap': hasNoWrap }" [innerHTML]="contentText"></div>
      @if (!hideAppStoreButtons) {
        <div class="store-buttons-container">
          <div class="app-store">
            <a id="appStore" target="_blank" [href]="appStoreUrl">
              <img alt="App Store" ngSrc="/assets/images/apple-app-store.svg" i18n-alt />
            </a>
          </div>
          <div class="google-play">
            <a id="googlePlay" target="_blank" [href]="playStoreUrl">
              <img alt="Google Play" ngSrc="/assets/images/google-play-store.svg" i18n-alt />
            </a>
          </div>
        </div>
      }
      <div class="buttons-container">
        <div class="left">
          <button
            class="button primary-button helper-full-width"
            type="submit"
            mat-dialog-close="confirm"
            [id]="confirmButtonId"
          >
            {{ confirmText }}
          </button>
        </div>
        @if (!hideCenterButton) {
          <div class="center">
            <button
              class="button secondary-button helper-full-width"
              type="submit"
              mat-dialog-close="discard"
              [id]="centerButtonId"
            >
              {{ centerButtonText }}
            </button>
          </div>
        }
        @if (!hideCancelButton) {
          <div class="right">
            <button
              class="button secondary-button cancel"
              type="button"
              mat-dialog-close="cancel"
              [id]="cancelButtonId"
            >
              {{ cancelText }}
            </button>
          </div>
        }
      </div>
    </div>
  }
</div>
